import { EnvironmentVariable, getEnvValue } from '../env';

export function getFontFullPath(fontName: string): string {
  return `${getEnvValue(EnvironmentVariable.CLOUDFRONT_STATIC_ASSET_URL)}content-lab/fonts/${fontName}`;
}
